import { useSession } from "contexts/AuthContext";
import { useTranslation } from "react-i18next";
import { Text } from "components/text";

export const HomeHeader = () => {
  const { user } = useSession();
  const { t } = useTranslation(["home"]);

  const getTimeOfDay = () => {
    const currentHour = new Date().getHours();
    if (currentHour < 12) {
      return t(`home:greeting.morning`, { name: user.firstName });
    }
    if (currentHour < 18) {
      return t(`home:greeting.afternoon`, { name: user.firstName });
    }
    return t(`home:greeting.evening`, { name: user.firstName });
  };

  const greeting = getTimeOfDay();

  return (
    <div className="space-y-2 text-secondary-800 text-center">
      <Text as="div" variant="pageHeading">
        {greeting}
      </Text>
      <Text as="div" variant="display">
        {t("home:greeting.description")}
      </Text>
    </div>
  );
};
